/**
 * Frontend API Client
 * 前台 API 客户端 - 支持 Node 和 PHP 双服务
 * 使用 shared 公共拦截器
 */
import axios from 'axios';
import { responseInterceptor, errorInterceptor } from '../../shared/api/interceptors';

// Node API (本地开发/职位数据)
const getNodeApiUrl = () => {
  if (import.meta.env.VITE_NODE_API_BASE_URL !== undefined) {
    return import.meta.env.VITE_NODE_API_BASE_URL;
  }
  if (import.meta.env.VITE_API_BASE_URL !== undefined) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  return 'http://localhost:8084';
};

const NODE_API_URL = getNodeApiUrl();

// PHP API (原有投递服务)
const getPhpApiUrl = () => {
  if (import.meta.env.VITE_PHP_API_BASE_URL !== undefined) {
    return import.meta.env.VITE_PHP_API_BASE_URL;
  }
  if (import.meta.env.VITE_JOB_API_BASE_URL !== undefined) {
    return import.meta.env.VITE_JOB_API_BASE_URL;
  }
  return 'https://testjob.uhomes.com';
};

const PHP_API_URL = getPhpApiUrl();

// Node 服务客户端 (职位列表、详情等)
const nodeClient = axios.create({
  baseURL: NODE_API_URL + '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// PHP 服务客户端 (投递、简历上传)
const phpClient = axios.create({
  baseURL: PHP_API_URL + '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// 使用 shared 公共拦截器
nodeClient.interceptors.response.use(responseInterceptor, errorInterceptor);
phpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

// 默认导出 Node 客户端（兼容现有代码）
export default nodeClient;

// 导出 PHP 客户端（投递专用）
export { phpClient };
